// 引用用户请求api
import {
  hello,
  login,
  userInfo
} from '../../apis/user'
import {
  localSet,
  localGet,
  localRemove
} from '@/common/storage.js'

// 下面我是示例的微信小程序的参数，可自行修改请求参数
const user = {
  namespaced: true,
  state: {
    /*
      userInfo: 基础字段
        token
        nickName
        avatar
        userId
    */
    userInfo: localGet('userInfo') || {},
    isIniting: false // login接口是否在请求中
  },
  mutations: {
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
      console.log('设置用户信息', userInfo)
      if (userInfo.has_pay) REPORT_SDK.set_attr('pay_state', 1)
      localSet({
        name: 'userInfo',
        value: userInfo
      })
    },
    SET_INIT_STATUS: (state, isIniting) => {
      state.isIniting = isIniting
    },
    CLEAR_TOKEN: (state) => {
      state.userInfo.token = undefined
      localRemove('token')
    }
  },
  actions: {
    async initUserInfo({
      commit
    }, {
      code,
      phone_code
    }) {
      console.log(22, code)
      // if (localGet('userInfo') && localGet('token')) {
      //   console.log('本地存在用户信息和token')
      //   return
      // }
      const res = await hello({
        random_id: parseInt(Math.random() * 99999999)
      })
      const
        data = await login({
          auth_code: code,
          dna: res.Dna,
          phone_code
        })
      console.log(33, data)
      commit('SET_USER_INFO', data)
      localSet({
        name: "token", // 存入的名字
        value: data.token, // 存入的值
        expires: 2586000, // 过期时间
      })
      commit('SET_INIT_STATUS', false)
    },
    // 请求userInfo 并存到store
    setUserInfo({
      commit
    }) {
      userInfo().then((res) => {
        // localSet({
        //   name: "token", // 存入的名字
        //   value: res.token, // 存入的值
        //   expires: 3600, // 过期时间
        // })
        commit('SET_USER_INFO', res)
        console.log('setUserInfo')
      })
    }
  }
}
export default user
